/* eslint-disable @next/next/no-img-element */
import Image from 'next/image'
import { Grid, Typography, Box, Button } from '@mui/material'

const Block1 = () => {
  return (
    <>
      <Grid container lg={12} className='mt-120 mb-20 items-center'>
        {/* Image on the left */}
        <Grid item xs={12} md={4} lg={4}>
          <img
            src={`${process.env.IMAGE_BASE_URL}/images/about/Group+8.png`}
            alt='image'
            className='rounded-4'
            style={{
              marginBottom: '12px'
            }}
          />
          <h5
            style={{
              textAlign: 'center',
              maxWidth: '300px',
              width: '300px',
              margin: 'auto'
            }}
          >
            ABDULRAHMAN RASHED MATAR ALJABRI
            <br />
            <span style={{
              fontSize: '14px'
            }}>CEO</span>
           
          </h5>
        </Grid>

        {/* Content on the right */}
        <Grid item xs={12} md={8} lg={8}>
          <Grid container spacing={3}>
            {/* First and Second Paragraphs */}
            <Grid className='mission_text_center' item xs={12} md={6} lg={6}>
              <h2 className='text-30 fw-600 ml-20'>MISSION</h2>
              <p
                className='text-dark-1'
                style={{
                  padding: '20px'
                }}
              >
                Our mission is to offer seamless access to top-tier travel
                services in the UAE. We want to enhance your entire travel
                journey, simplifying your booking and travel experience with us.
                <br />
              </p>
            </Grid>

            {/* Third Paragraph */}
            <Grid className='mission_text_center' item xs={12} md={6} lg={6}>
              <h2 className='text-30 fw-600 ml-20'>VISION</h2>
              <p
                className='text-dark-1'
                style={{
                  padding: '20px'
                }}
              >
                Our vision at Royal Smart Limousine is to establish ourselves as
                the best travel application and web portal, encouraging people
                to set out on fantastic journeys.
                <br />
              </p>
            </Grid>

            {/* Full Width Grid for Third Paragraph */}
            <Grid className='mission_text_center' item xs={12} md={12} lg={12}>
              <h2 className='text-30 fw-600 ml-20'>OUR PROMISE</h2>
              <p
                className='text-dark-1'
                style={{
                  padding: '20px'
                }}
              >
                We promise to deliver exceptional experiences that create
                lasting memories for you. We offer unforgettable journeys with
                personalized packages tailored to your preferences and budget.
                Our reliable travel services add convenience and elegance to
                your transfers. Our commitment to reliability, trust, and
                customer satisfaction ensures that your journey with us is truly
                remarkable.
                <br />
              </p>
            </Grid>
          </Grid>
        </Grid>
        <div style={{ marginTop: '100px' }}>
          <img
            src={`${process.env.IMAGE_BASE_URL}/images/about/footer.png`}
            alt='Investor Image'
            className='investor_Img'
          />
          <div className='d-flex align-items-center justify-content-start'>
            <img
              src={`${process.env.IMAGE_BASE_URL}/images/contactUs/bar.png`}
              alt='contact-card'
              className='contact-card__barcode'
            />
            <div>
              <div className='d-flex align-items-center'>
                <h5> Download the RSL Super app</h5>
                <i className='icon icon-chevron-right text-17 ml-4'></i>
              </div>
              <div>Scan to download</div>
            </div>
          </div>
        </div>
      </Grid>

      {/* <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        className="mt-120 mb-20"
        style={{
          backgroundColor: "#6cc8bf", // Match the background color in the image
          padding: "40px",
          borderRadius: "20px",
        }}
      >

        <Grid item xs={12} md={6} lg={6}>
          <Typography
            variant="h4"
            fontWeight="bold"
            color="white"
            gutterBottom
          >
            The Easiest Way to Book Your Ride <br />
            Download Our App for Instant Access
          </Typography>


          <Box display="flex" gap={2} mt={2}>
            <Button
              href="https://apps.apple.com/"
              target="_blank"
              style={{ padding: 0 }}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/2560px-Download_on_the_App_Store_Badge.svg.png"
                alt="Download on the App Store"
                style={{ width: "150px" }}
              />
            </Button>
            <Button
              href="https://play.google.com/store/"
              target="_blank"
              style={{ padding: 0 }}
            >
              <img
                src="https://cdn.pixabay.com/photo/2021/09/22/16/07/google-play-6647242_960_720.png"
                alt="Get it on Google Play"
                style={{ width: "150px" }}
              />
            </Button>
          </Box>
        </Grid>


        <Grid item xs={12} md={6} lg={6} display="flex" justifyContent="center">
          <img
            src={`${process.env.IMAGE_BASE_URL}/images/about/footer.png`}
            alt="App Showcase"
            style={{
              width: "100%",
              maxWidth: "500px",
              borderRadius: "20px",
            }}
          />
        </Grid>
      </Grid> */}
    </>
  )
}

export default Block1
